import { Button, Result } from 'antd'
import PageLoadingIndicator from 'components/PageLoadingIndicator';
import { useEffect, useState } from 'react';

const PageNotFoundPage = (props: { message?: string, hideBackToStartButton?: boolean, delayMs?: number }) => {
  const { message, hideBackToStartButton, delayMs } = props
  const [showError, setShowError] = useState(!delayMs)

  useEffect(() => {
    if (delayMs)
      setTimeout(() => setShowError(true), delayMs);
    // eslint-disable-next-line
  }, [])

  if (showError)
    return <Result
      status="404"
      title="404"
      subTitle={message || "Desculpe, a página solicitada não existe."}
      extra={hideBackToStartButton ? null :
        <Button
          type="primary"
          href="/"
        >
          Voltar ao início
        </Button>}
    />

  else
    return <PageLoadingIndicator
      debug={'PageNotFoundPage initial loading'}
    />

};

export default PageNotFoundPage;
